import { Field, useFormikContext } from 'formik';
import React, { FC, useEffect } from 'react';
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { validateIpAddress } from '../../../../utilities/Validation';
import Label from '../../../label/label';

interface AddIpRangeProps {
    setFormikContext: (formikContext) => void
}

export const AddIpRangeCard: FC<AddIpRangeProps> = ({setFormikContext}) => {
    const { translate } = useLocale();
    const formikContext = useFormikContext<any>();

    useEffect(() => {
        setFormikContext(formikContext)
    }, [])

    return <>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='startIpLabelId'>
                    <Label
                        htmlFor="startIp"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.startIpAddress)}:</Label>
                    {formikContext.errors.startIp ? <span className='text-red-600 text-xs'>{formikContext.errors.startIp}</span> : null}
                </div>
                <Field id='startIpInputFieldId'
                    type="text"
                    name="startIp"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => validateIpAddress(value, translate, true)} />
            </div>
        </div>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='endIpLabelId'>
                    <Label
                        htmlFor="endIp"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.endIpAddress)}:</Label>
                    {formikContext.errors.endIp ? <span className='text-red-600 text-xs'>{formikContext.errors.endIp}</span> : null}
                </div>
                <Field id='endIpFieldId'
                    type="text"
                    name="endIp"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => validateIpAddress(value, translate, true)} />
            </div>
        </div>
    </>
};
